export default __webpack_public_path__ + "static/media/lion-of-judah.bda1d24b.png";